import React, { useState } from 'react';
import { Container, Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { PageIndices, TabIndices } from '../common/i-doc/i-doc.registry.ts';
import { LoginForm } from '../components/LoginForm';
import { RegisterForm } from '../components/RegisterForm';
import { PasswordResetForm } from '../components/PasswordResetForm';
import { AdaptiveTabs, AdaptiveTabItem } from '../components/common/AdaptiveTabs';

type View = 'auth' | 'reset';

const AUTH_TABS: AdaptiveTabItem[] = [
  { value: 'login', label: 'Вхід', iDoc: TabIndices.AUTH_LOGIN },
  { value: 'register', label: 'Реєстрація', iDoc: TabIndices.AUTH_REGISTER },
  { value: 'register-expert', label: 'Реєстрація експерта', iDoc: TabIndices.AUTH_REGISTER_EXPERT },
];

export const AuthPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [view, setView] = useState<View>('auth');
  const [userEmail, setUserEmail] = useState('');

  const currentTab = searchParams.get('tab') || 'login';

  const handleSwitchToReset = (email: string) => {
    setUserEmail(email);
    setView('reset');
  };

  const handleBackToLogin = () => {
    setView('auth');
    setSearchParams({ tab: 'login' });
  };

  if (view === 'reset') {
    return (
      <Container maxWidth="sm" data-i-doc={PageIndices.AUTH}>
        <PasswordResetForm
          onBackToLogin={handleBackToLogin}
          initialEmail={userEmail}
        />
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" data-i-doc={PageIndices.AUTH}>
      <Box sx={{ mt: 4 }}>
        <AdaptiveTabs
          tabs={AUTH_TABS}
          searchParamKey="tab"
          defaultValue="login"
        />
      </Box>

      {currentTab === 'login' && <LoginForm onSwitchToPasswordReset={handleSwitchToReset} />}

      {currentTab === 'register' && (
        <RegisterForm
          role="client"
          title="Реєстрація клієнта"
          onSwitchToLogin={() => {
            setSearchParams({ tab: 'login' });
          }}
        />
      )}

      {currentTab === 'register-expert' && (
        <RegisterForm
          role="expert"
          title="Реєстрація експерта"
          onSwitchToLogin={() => {
            setSearchParams({ tab: 'login' });
          }}
        />
      )}
    </Container>
  );
};
